/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useMemo } from "react";

import { useClient } from "../ClientContext";
import { E2eeType } from "./e2eeType";

export type Unencrypted = { kind: E2eeType.NONE };
export type PerParticipantE2EE = { kind: E2eeType.PER_PARTICIPANT };
export type EncryptionSystem = Unencrypted | PerParticipantE2EE;

/**
 * Определяет шифрование медиапотоков по наличию события m.room.encryption.
 */
export function useRoomEncryptionSystem(roomId: string): EncryptionSystem {
  const { client } = useClient();
  const room = client?.getRoom(roomId);

  return useMemo(
    () =>
      room?.hasEncryptionStateEvent()
        ? { kind: E2eeType.PER_PARTICIPANT }
        : { kind: E2eeType.NONE },
    [room],
  );
}
